// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const ja: ChromeTranslations = {
  'nav.nextPage': '次のページ →',
  'nav.previousPage': '← 前のページ',
  'nav.continueToLevel': 'ステージへ進む →',
  'nav.backToMenu': 'メニューに戻る →',
  'howto.page': '{total} ページ中 {n} ページ',
  'options.title': 'オプション',
  'ui.language': '言語',
};
